<template>
  <div class="footer-bar" onclick="easemobim.bind({configId: '06bb7b4c-3b33-4c3e-b1c5-9d69925133ef'})" >
    <img src="/eosrent/images/contact-icon.png" alt="">
    <span>{{$t('index.header-title-contact-us')}}</span>

    <feedbackModal v-if="feedbackParams.iframeShow" :refs="feedbackParams" ></feedbackModal>
  </div>
</template>

<style lang="less" scoped>

</style>

<script>
import feedbackModal from './feedback_modal'

export default {
  data () {
    return {
      feedbackParams: {
        iframeShow: false
      }
    }
  },
  mixins: [],
  components: {
    feedbackModal
  },
  mounted () {

  },
  methods: {
    // 联系我们
    /* eslint-disable */
    feedbackClick () {
      var self = this;
      var w = window.addEventListener ? 'addEventListener' : 'attachEvent',
        x = window[w],
        E = ('attachEvent' === w ? 'onmessage' : 'message');
      x(E, function (e) {
        var n = e.message ? 'message' : 'data',
          r = e[n];
        'closeIframe' === r.childStatus && (self.feedbackParams.iframeShow = false)
      });
      this.feedbackParams.iframeShow = true;
    },
    /* eslint-enable */
  }
}
</script>



// WEBPACK FOOTER //
// src/components/footer.vue